import { useParams } from "react-router-dom"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { InvoicesAdmin } from "~/pages/Admin/Invoices/InvoicesAdmin"
import { useListInvoicesQuery } from "~/pages/Admin/Invoices/hooks"

export const InvoicesAdminWrapper = () => {
  const params = useParams()
  const organizationId = params.organizationId?.toString() ?? ""

  const invoicesQuery = useListInvoicesQuery(organizationId)

  return (
    <DataFetchWrapper query={invoicesQuery} acceptEmpty={true}>
      {({ data }) => <InvoicesAdmin invoices={data} />}
    </DataFetchWrapper>
  )
}
